import { anomalyAnalysis } from './anomalyAnalysis'
import { clientSummary } from './clientSummary'
import { costAnalysis } from './costAnalysis'
import { departmentPerformance } from './departmentPerformance'
import { employeePerformance } from './employeePerformance'
import { executiveSummary } from './executiveSummary'
import { vehiclePerformance } from './vehiclePerformance'
import { wasteAnalysis } from './wasteAnalysis'
import { assignmentAnalysis } from './assignmentAnalysis'

export const actions = [
  employeePerformance,
  vehiclePerformance,
  wasteAnalysis,
  assignmentAnalysis,
  anomalyAnalysis,
]

export const execActions = [
  clientSummary,
  executiveSummary,
  wasteAnalysis,
  assignmentAnalysis,
  departmentPerformance,
  costAnalysis,
]
